export function getScrollTop(): number {
  const doc = document.documentElement;
  return (window.pageYOffset || (doc ? doc.scrollTop : 0)) - ((doc ? doc.clientTop : 0) || 0);
}

export function getMaxScroll(windowHeight: number): number {
  return (document && document.documentElement ? document.documentElement.offsetHeight : 0) - windowHeight;
}



// WEBPACK FOOTER //
// src/app/src/utils/index.ts